const headerDarkMode = () => {
	const siteHeader = document.querySelector('.site-header');

	if (!siteHeader) {
		return;
	}

	siteHeader.addEventListener('mouseenter', (e) => {
		siteHeader.classList.add('active');
	});
	siteHeader.addEventListener('mouseleave', (e) => {
		siteHeader.classList.remove('active');
	});
};

window.addEventListener('DOMContentLoaded', () => {
	headerDarkMode();
});
